






















import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import Popup, { PopupConfiguration } from '@/embed/widget/components/Popup.vue'
import Avatar, { AvatarConfiguration } from '@/embed/widget/components/Avatar.vue'
import { WidgetAvatarStyle, WidgetFlowType, WidgetPopupPosition, WidgetType } from '@/api/types'
import { WidgetAction, WidgetIframeUrls } from '@/embed/widget/actions'
import IconCross from '@/components/icons/IconCross.vue'

export interface KVConfiguration {
    companyId: string
    companyName: string,
    enabled: boolean
    avatarStyle: WidgetAvatarStyle
    avatarBackground: string
    type: WidgetType
    flows: WidgetFlowType[]
    avatar: AvatarConfiguration
    popup: PopupConfiguration,
    tag: string
}

export const KVEventBus = new Vue()

@Component({
    components: {
        Popup,
        Avatar,
        IconCross,
    },
})
export default class App extends Mixins(VhFixMixin) {
    @Prop() configurationQuerySelector!: string
    @Prop({default: null}) configuration!: KVConfiguration|null
    @Prop({default: false}) absolute!: boolean
    @Prop({default: false}) noIframe!: boolean
    modalUrl: string|null = null

    mounted() {
        document.addEventListener('click', this.listen, true)
    }

    listen(event) {
        const actions: WidgetAction[] = Object.values(WidgetAction)
        const urls: string[] = actions.map(value => process.env.VUE_APP_KEYVUE_WIDGET_BASEURL + value)
        let href: string
        let target = event.target

        // bubble event up until we reach the link or reach end of document
        while (!['body', 'html'].includes(target.tagName.toLowerCase()) && !target.hasAttribute('href')) {
            target = target.parentNode
        }

        // end if we reached end of document
        if (!target.hasAttribute('href')) {
            return
        }

        href = target.href

        if (!urls.includes(href)) {
            return
        }

        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()

        if (this.noIframe) {
            return
        }

        const action: string = href.replace(process.env.VUE_APP_KEYVUE_WIDGET_BASEURL, '')
        const key: WidgetAction = Object.values(WidgetAction).find(value => value as string === action)

        KVEventBus.$emit(key)

        this.openIframe(key)
    }

    openIframe(key: WidgetAction) {
        if (!Object.keys(WidgetIframeUrls).includes(key)) {
            return
        }

        /** Casting to string because of TS2352, WidgetFlowType values contain some of the same values */
        if (!Object.values(this.internalConfiguration.flows).includes(key as string as WidgetFlowType)) {
            return
        }

        this.modalUrl = process.env.VUE_APP_KEYVUE_FRONTEND_BASEURL +
            WidgetIframeUrls[key] +
            '?company=' + this.internalConfiguration.companyId +
            '&companyName=' + this.internalConfiguration.companyName +
            '&tag=' + this.internalConfiguration.tag
    }

    get show(): boolean {
        return this.internalConfiguration ? this.internalConfiguration.enabled : false
    }

    get iframeClasses(): object {
        return {
            'kv-iframe': true,
            'kv-iframe--right': this.iframeRight,
            'kv-iframe--left': this.iframeLeft,
        }
    }

    get iframeRight(): boolean {
        return this.internalConfiguration.type === WidgetType.AVATAR || (
                this.internalConfiguration.type === WidgetType.POPUP &&
                this.internalConfiguration.popup.position === WidgetPopupPosition.LEFT
            )
    }

    get iframeLeft(): boolean {
        return this.internalConfiguration.type === WidgetType.POPUP &&
            this.internalConfiguration.popup.position === WidgetPopupPosition.RIGHT
    }

    get internalConfiguration(): KVConfiguration {
        if (this.configuration) {
            return this.configuration
        }

        if (this.configurationQuerySelector) {
            const configurationElement = document.querySelector(this.configurationQuerySelector)
            return JSON.parse(configurationElement.innerHTML)
        }

        console.error('KV configuration not found')
    }

    get componentClasses(): object {
        return {
            'kv-initial': true,
            'kv-initial--absolute': this.absolute,
        }
    }
}
